import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

const TestimonialsCarousel = () => {
  const testimonials = [
    {
      name: "Mr. Paul Pandi",
      company: "Vasantham Pattasu Kadai",
      campaign: "Our Successfully Completed Diwali Campaign - 2024",
      feedback:
        "Very Nice team to work with this year and very eager to work for the upcoming years. I am also happy to work and happy to spend the time with the team. Thank you very much team hanatoria.",
      image: "./Logo/testi1.png",
    },
    {
      name: "Mrs. Raji Suresh",
      company: "Vdhya",
      campaign: "They Turned Our Vision Into a Symbol",
      feedback:
        "We had a great experience working with Hanatoria Design Studio, who designed the logo for our website - 'Vdhya '. They understood our vision, delivered a creative and professional design, and were responsive throughout the process.",
      image: "./Logo/testi2.png",
    },
    {
      name: "Mr. Arun",
      company: "Talkgram",
      campaign: "Consistent. Reliable. Excellent.",
      feedback:
        "Hanatoria has completed various services for Talkgram, including flyers, standees, and business cards. What truly sets them apart is their consistent, on-time delivery, along with excellent service.",
      image: "./assets/png/logo/Fit4 life-18.png",
    },
    {
      name: "Mr. Shriram Jayachandran",
      company: "Eyeshore",
      feedback:
        "Hanatoria team has designed a very wonderful logo. It represents an increasing reputation and brand value and also, I got pamphlet posters, which is very unique, receiving customers very well.",
      campaign: "A Logo That Builds Reputation, Designs That Attract Customers",
      image: "./Logo/testi5.png",
    },

    {
      name: "Mr. Kishore",
      company: "Kalam Foundation",
      campaign: "They Don’t Just Deliver They Adapt, Listen & Elevate",
      feedback:
        "They meet our expectations very much. My personal experience with them was awesome. Very polite, patient, adapt to changes every time & so. Kudos guys. Keep going . I strongly recommend them.",
      image: "./Logo/testi4.png",
    },
    {
      name: "Mr. Vinay K S",
      company: "Sativa",
      campaign: "A Logo That Brewed Just Right for Our Café",
      feedback:
        "We contacted the Hanatoria team for the logo design of our Cafe Sativa through the reference of a friend! We loved the work of Ms. Mohandeepa and her team! An extremely talented group of people! Very professional!",
      image: "./Logo/testi3.png",
    },
  ];

  const settings = {
    autoplay: false,
    centerMode: false,
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <FontAwesomeIcon icon={faArrowLeft} className="prev-arrow" />,
    nextArrow: <FontAwesomeIcon icon={faArrowRight} className="next-arrow" />,
    responsive: [
      {
        breakpoint: 1700,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 991,
        settings: { slidesToShow: 1 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
      {
        breakpoint: 575,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <div
      className="container mx-auto p-4 sm:p-6 md:p-8 lg:p-0 rounded-xl relative mb-[4rem] max-w-[1900px]"
      style={{
        backgroundImage: "url('/assets/svg/plain_dot.svg')",
      }}
    >
      {/* Title Section at the Top */}
      <div className="text-center mb-10">
        <p className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-inter font-medium leading-extra-loose text-[#1E1A1C]">
          What Our Clients Say
        </p>
        <h1 className="text-[#363435] text-lg sm:text-xl md:text-2xl font-lexend font-light leading-7">
          Discover the impact we’ve made through our clients’ words.
        </h1>
      </div>

      {/* Decorative Gradient Image */}
      <img
        src="/assets/png/Ellipse_right.png"
        alt="gradient"
        className="absolute top-0 right-0 z-0"
      />

      {/* Slider Section */}
      <div className="relative z-10 py-6">
        <Slider {...settings} className="w-full">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="flex flex-col justify-start testimonial-cards md:px-[10px] h-full"
            >
              <div className="bg-[#FFF5DE] p-[1.5rem] rounded-lg w-full max-w-sm md:max-w-xl mx-auto flex flex-col md:flex-row items-start space-y-4 lg:space-y-0 lg:space-x-6 min-h-[320px] h-full">
                <div className="text-center lg:text-left justify-between h-full">
                  <div>
                    <h3 className="text-sm sm:text-base md:text-xl font-semibold font-inter">
                      {testimonial.campaign}
                    </h3>
                    <p className="text-[#1E1A1C] mt-2 text-xs sm:text-sm md:text-lg font-lexend font-light">
                      "{testimonial.feedback}"
                    </p>
                  </div>

                  <div className="mt-4 flex flex-col md:flex-row justify-between">
                    <div className="w-[70%]">
                      <p className="font-semibold text-[#F15A28] text-xs sm:text-xl leading-7 font-lexend">
                        {testimonial.name}
                      </p>
                      <p className="text-black text-xs sm:text-sm font-lexend font-normal">
                        {testimonial.company}
                      </p>
                      <div className="flex mt-2 text-yellow-400 justify-center lg:justify-start">
                        <span className="fas fa-star"></span>
                        <span className="fas fa-star"></span>
                        <span className="fas fa-star"></span>
                        <span className="fas fa-star"></span>
                        <span className="fas fa-star-half-alt"></span>
                      </div>
                    </div>
                    <div className="relative w-full lg:w-[28%] mt-4 lg:mt-0">
                      <div className="block lg:hidden">
                        {/* Mobile: absolutely positioned logo at bottom right */}
                        <img
                          src={testimonial.image}
                          alt="logo"
                          className="absolute right-0 bottom-[-30px] md:bottom-[-15px] w-[40%] sm:w-25"
                        />
                      </div>
                      <div className="hidden lg:block">
                        {/* Desktop: normal positioning */}
                        <img
                          src={testimonial.image}
                          alt="logo"
                          className="w-full lg:w-[95%]"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default TestimonialsCarousel;



          {/* <div
            key={index}
            className="flex justify-center testimonial-cards md:px-[10px] "
          >
            <div className="bg-[#FFF5DE] p-[1.5rem 1.5rem 0 1.5rem]  rounded-lg w-full max-w-sm md:max-w-[21rem] lg:max-w-xl flex flex-col lg:flex-row items-center space-y-4 lg:space-y-0 lg:space-x-6">
             
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="w-16 sm:w-20 lg:w-52  object-cover rounded-lg px-1 py-1"
              />

   
              <div className="text-center lg:text-left pr-2">
                <h3 className="text-sm sm:text-base md:text-lg font-semibold font-inter">
                  {testimonial.campaign}
                </h3>
                <p className="text-[#1E1A1C] mt-2 text-xs sm:text-sm md:text-base font-lexend font-light">
                  "{testimonial.feedback}"
                </p>

                <div className="mt-4">
                  <p className="font-semibold text-[#F15A28] text-xs sm:text-xl leading-7 font-lexend">
                    {testimonial.name}
                  </p>
                  <p className="text-black text-xs sm:text-sm font-lexend font-normal">
                    {testimonial.company}
                  </p>
                </div>

               
                <div className="flex mt-4 text-yellow-400 justify-center lg:justify-start">
                  <span className="fas fa-star"></span>
                  <span className="fas fa-star"></span>
                  <span className="fas fa-star"></span>
                  <span className="fas fa-star"></span>
                  <span className="fas fa-star-half-alt"></span>
                </div>
              </div>
            </div>
          </div> */}